export const actionTypes = {
  TOGGLE_MODAL: 'users/TOGGLE_MODAL',
  HANDLE_EMAIL_CHANGE: 'users/HANDLE_EMAIL_CHANGE',

  FETCH_USERS: 'users/FETCH_USERS',
  DELETE_USER: 'users/DELETE_USER',
  SEND_REPORT: 'users/SEND_REPORT',
}
